/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * A CIMD document URL explicitly allowed on a user_session_issuer, additive to the preset catalog.
 */
export type UserSessionIssuerCimdClient = {
  /**
   * The exact https URL admitted as a client_id.
   */
  clientIdMetadataUri: string;
  createdAt: Date;
  /**
   * The user_session_issuer_cimd_client id.
   */
  id: string;
  /**
   * The owning organization id.
   */
  organizationId: string;
  /**
   * The owning project id; empty for organization-owned entries.
   */
  projectId: string;
  updatedAt: Date;
  /**
   * The user_session_issuer this URL is allowed on.
   */
  userSessionIssuerId: string;
};

/** @internal */
export const UserSessionIssuerCimdClient$inboundSchema: z.ZodMiniType<
  UserSessionIssuerCimdClient,
  unknown
> = z.pipe(
  z.object({
    client_id_metadata_uri: z.string(),
    created_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    id: z.string(),
    organization_id: z.string(),
    project_id: z.string(),
    updated_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    user_session_issuer_id: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "client_id_metadata_uri": "clientIdMetadataUri",
      "created_at": "createdAt",
      "organization_id": "organizationId",
      "project_id": "projectId",
      "updated_at": "updatedAt",
      "user_session_issuer_id": "userSessionIssuerId",
    });
  }),
);

export function userSessionIssuerCimdClientFromJSON(
  jsonString: string,
): SafeParseResult<UserSessionIssuerCimdClient, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UserSessionIssuerCimdClient$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UserSessionIssuerCimdClient' from JSON`,
  );
}
